import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsAutoProlongAvailable, selectAutoProlongTooltipText } from '../../selectors/checkoutInfo';
import { selectIsMobileLayout } from '../../selectors/layout';
import { selectCheckoutDetails } from '../../selectors/publishTerms';
import { Checkout } from './Checkout';

export const CheckoutContainer = () => {
  const details = useSelector(selectCheckoutDetails);
  const isAutoProlongAvailable = useSelector(selectIsAutoProlongAvailable);
  const autoProlongTooltipText = useSelector(selectAutoProlongTooltipText);
  const isMobile = useSelector(selectIsMobileLayout);

  return (
    <Checkout
      details={details}
      isAutoProlongVisible={!isMobile && isAutoProlongAvailable}
      autoProlongTooltipText={!isMobile ? autoProlongTooltipText : undefined}
    />
  );
};
